/**
 * Database Backup Service
 * Handles backup status monitoring, S3 file listing, and download URLs
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { DATABASE_BACKUP_ENDPOINTS, buildQueryString } from '../endpoints';

const databaseBackupService = {
  /**
   * Get current backup status with health computation
   * @returns {Promise<Object>} BackupStatusDto
   */
  getStatus: async () => {
    return apiRequest(() =>
      axiosInstance.get(DATABASE_BACKUP_ENDPOINTS.STATUS)
    );
  },

  /**
   * List backup files from S3
   * @param {Object} params - Optional filters: type (full), database
   * @returns {Promise<Array>} List of BackupFileDto
   */
  getFiles: async (params = {}) => {
    return apiRequest(() =>
      axiosInstance.get(`${DATABASE_BACKUP_ENDPOINTS.FILES}${buildQueryString(params)}`)
    );
  },

  /**
   * Get a presigned download URL for a backup file
   * @param {string} key - S3 object key
   * @returns {Promise<Object>} BackupDownloadDto with presignedUrl, fileName, expiresAt
   */
  getDownloadUrl: async (key) => {
    return apiRequest(() =>
      axiosInstance.get(`${DATABASE_BACKUP_ENDPOINTS.DOWNLOAD}${buildQueryString({ key })}`)
    );
  },

  /**
   * Trigger a database restore from an S3 backup file
   * @param {Object} params - { s3Key, targetDatabase }
   * @returns {Promise<Object>} RestoreDatabaseResponseDto
   */
  restoreDatabase: async ({ s3Key, targetDatabase }) => {
    return apiRequest(() =>
      axiosInstance.post(DATABASE_BACKUP_ENDPOINTS.RESTORE, { s3Key, targetDatabase })
    );
  },
};

export default databaseBackupService;
